import { useNavigate } from "react-router-dom";
import "./home.css";
import "./BackgroundInfo.css";
import ParliamentCards from "../components/ParliamentCards";
import { FaCheckCircle } from "react-icons/fa";
import parliamentLayout from "../assets/backgroundinfo_background4.png";

const BackgroundInfo = () => {
  const navigate = useNavigate();

  // const handleKnowMore = () => {
  //   // Add navigation logic here if needed
  //   console.log("Know More Clicked");
  //   // e.g., navigate('/learn-more');
  // };

  const checklist = [
    "I’m 18 Or Older",
    "I’m An Australian Citizen",
    "I’m Enrolled To Vote",
  ];

  return (
    <div className="home-container">
      <div className="background-section">
        <div className="overlay-blur">
          <div className="overlay-content">
            <h1>
              New To Voting? <br /> Start Here
            </h1>
            <div className="vertical-spacer"></div>
            <div className="white-text">
              Everything You Need To Know About Parliament
              <br />
              And How To Vote — No Jargon, Just Answers.
            </div>
            <button onClick={() => navigate("/inforfrombackground")}>
              Know More
            </button>
          </div>
        </div>
      </div>
      <div className="background-section2">
        <div className="overlay-blur">
          <div className="overlay-content-static">
            <h1>Why does Parliament even matter?</h1>
            <div className="vertical-spacer"></div>
            <p>
              Parliament is where laws that affect your daily life are made —
              like housing, jobs, uni fees, and climate action.
            </p>
            <ParliamentCards />
          </div>
        </div>
      </div>

      <div className="vote-section">
        <h2>Do I Need To Vote?</h2>
        <ul className="vote-check-list">
          {checklist.map((item, index) => (
            <li key={index}>
              <FaCheckCircle className="check-icon" />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="transparency-section">
        <h2>How Do I Know Who’s Actually Doing A Good Job?</h2>
        <div className="transparency-content">
          <img
            src={parliamentLayout}
            alt="Parliament Layout"
            className="parliament-img"
          />

          <div className="transparency-info">
            <div className="transparency-item">
              <div>
                <h3>🧾 Check how they voted: </h3>
                <p>
                  Did Your MP Support Climate Action? Cheaper Uni? <br />
                  You Can Look Up How They Voted On Real Bills In Parliament.
                </p>
              </div>
            </div>

            <div className="transparency-item">
              <div>
                <h3>📢 Read their speeches: </h3>
                <p>
                  What Did They Say In Parliament? You Can Search Debates And
                  Speeches <br />
                  Using Keywords Like “Housing” Or “Mental Health.”
                </p>
              </div>
            </div>

            <button className="try-now-btn" onClick={() => navigate("/ask")}>
  Try now
</button>

          </div>
          <p className="transparency-footer">
            Don’t Just Go By Headlines. <br />
            Go By Their Record. <br />
            Politicians Must Show What They Support — And It’s Public.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BackgroundInfo;
